import { render, staticRenderFns } from "./DisplayCommunication.vue?vue&type=template&id=d4db4090&scoped=true&"
import script from "./DisplayCommunication.vue?vue&type=script&lang=js&"
export * from "./DisplayCommunication.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCommunication.vue?vue&type=style&index=0&id=d4db4090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4db4090",
  null
  
)

export default component.exports